import type { UIStringsOverride } from "../i18n-ui.ts";

/** Norwegian Bokmål (no) UI strings. */
export const no: UIStringsOverride = {
  actions: {
    addToCursor: "Legg til i Cursor",
    addToVscode: "Legg til i VS Code",
    askAI: "Spør AI om denne siden",
    connectMcp: "Koble til MCP",
    copied: "Kopiert!",
    copyClaudeCode: "Kopier Claude Code-kommando",
    copyCode: "Kopier kode",
    copyCodex: "Kopier Codex-kommando",
    copyMarkdown: "Kopier som Markdown",
    copyServerUrl: "Kopier server-URL",
    edit: "Rediger på GitHub",
    export: "Eksporter",
    exportEpub: "Eksporter til EPUB",
    exportPdf: "Eksporter til PDF",
    generating: "Genererer…",
    openIn: "Åpne i {name}",
    openInChat: "Åpne i chat",
    scrollToTop: "Til toppen",
  },
  ask: {
    ai: "AI",
    clear: "Tøm samtalen",
    close: "Lukk",
    copy: "Kopier samtalen",
    empty: "Still et spørsmål om dokumentasjonen.",
    error: "Beklager, noe gikk galt.",
    label: "Still et spørsmål",
    placeholder: "Still et spørsmål…",
    send: "Send",
    tip: "Tips: Du kan åpne og lukke chatten med",
    title: "Spør AI",
    you: "Du",
  },
  banner: { dismiss: "Lukk kunngjøringen" },
  changelog: {
    description: "Produktoppdateringer og utgivelsesnotater.",
    showReleases: "Vis utgivelser for {version}",
    title: "Endringslogg",
  },
  content: { diagramError: "Kunne ikke vise dette diagrammet." },
  feedback: {
    no: "Nei",
    question: "Var denne siden nyttig?",
    thanks: "Takk for tilbakemeldingen!",
    yes: "Ja",
  },
  languageSwitcher: { label: "Språk", untranslated: "Ikke oversatt" },
  nav: {
    back: "Tilbake",
    breadcrumb: "Brødsmulesti",
    closeNavigation: "Lukk navigasjonen",
    deprecated: "foreldet",
    featured: "Utvalgt",
    githubRepository: "GitHub-repositorium",
    navigation: "Navigasjon",
    primary: "Primær",
    sections: "Seksjoner",
    toggleNavigation: "Vis eller skjul navigasjonen",
    toggleTheme: "Bytt fargetema",
  },
  notFound: {
    description: "Vi fant ikke siden du leter etter.",
    home: "Tilbake til forsiden",
    title: "Siden ble ikke funnet",
  },
  page: {
    lastUpdated: "Sist oppdatert",
    next: "Neste",
    pagination: "Paginering",
    previous: "Forrige",
    skipToContent: "Hopp til innhold",
  },
  search: {
    all: "Alle",
    allLanguages: "Alle språk",
    askAi: "Spør AI",
    askAiHint: "Få et umiddelbart svar fra AI",
    button: "Søk",
    devOnly: "Søk er tilgjengelig i produksjonsbygget.",
    error: "Noe gikk galt. Prøv igjen.",
    label: "Søk i dokumentasjonen",
    navigate: "naviger",
    noResults: "Ingen resultater funnet.",
    open: "åpne",
    placeholder: "Søk i dokumentasjonen…",
    popular: "Populært",
    preview: "forhåndsvis",
    results: "Resultater",
  },
  toc: { title: "På denne siden" },
};
